import React, { Component } from 'react'

export default class BoxOffice extends Component {
    render() {
        return (
            <div className="wow fadeIn" data-wow-duration="3s">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <div className="omb-box-office">
                            <h5>Box Office UK <span>(last week)</span></h5>
                            <hr />
                            <ul className="omb-chart">
                                <li>
                                    <i>1</i>
                                    <a href="http://www.imdb.com/title/tt1398426/?ref_=fn_al_tt_1" target="_blank">
                                        Straight Outta Compton
              <span>$26.760.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>2</i>
                                    <a href="http://www.imdb.com/title/tt2381249/?ref_=fn_al_tt_1" target="_blank">
                                        Mission: Impossible - Rogue Nation
              <span>$11.700.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>3</i>
                                    <a href="http://www.imdb.com/title/tt2752772/?ref_=fn_al_tt_1" target="_blank">
                                        Sinister 2
              <span>$10.633.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>4</i>
                                    <a href="http://www.imdb.com/title/tt2679042/?ref_=fn_al_tt_1" target="_blank">
                                        Hitman: Agent 47
              <span>$8.200.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>5</i>
                                    <a href="http://www.imdb.com/title/tt1638355/?ref_=fn_al_tt_1" target="_blank">
                                        The Man from U.N.C.L.E.
              <span>$7.420.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>6</i>
                                    <a href="http://www.imdb.com/title/tt3316948/?ref_=fn_al_tt_1" target="_blank">
                                        American Ultra
              <span>$5.500.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>7</i>
                                    <a href="http://www.imdb.com/title/tt4178092/?ref_=fn_al_tt_1" target="_blank">
                                        The Gift
              <span>$4.300.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>8</i>
                                    <a href="http://www.imdb.com/title/tt0478970/?ref_=fn_al_tt_1" target="_blank">
                                        Ant-Man
              <span>$4.088.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>9</i>
                                    <a href target="_blank" onclick="return false;">
                                        The Gift
              <span>$3.710.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>10</i>
                                    <a href target="_blank" onclick="return false;">
                                        Ant-Man
              <span>$3.650.000</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <div className="omb-box-office">
                            <h5>Box Office US <span>(last week)</span></h5>
                            <hr />
                            <ul className="omb-chart">
                                <li>
                                    <i>1</i>
                                    <a href="http://www.imdb.com/title/tt1398426/?ref_=fn_al_tt_1" target="_blank">
                                        Straight Outta Compton
              <span>$26.760.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>2</i>
                                    <a href="http://www.imdb.com/title/tt2381249/?ref_=fn_al_tt_1" target="_blank">
                                        Mission: Impossible - Rogue Nation
              <span>$11.700.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>3</i>
                                    <a href="http://www.imdb.com/title/tt2752772/?ref_=fn_al_tt_1" target="_blank">
                                        Sinister 2
              <span>$10.633.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>4</i>
                                    <a href="http://www.imdb.com/title/tt2679042/?ref_=fn_al_tt_1" target="_blank">
                                        Hitman: Agent 47
              <span>$8.200.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>5</i>
                                    <a href="http://www.imdb.com/title/tt1638355/?ref_=fn_al_tt_1" target="_blank">
                                        The Man from U.N.C.L.E.
              <span>$7.420.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>6</i>
                                    <a href="http://www.imdb.com/title/tt3316948/?ref_=fn_al_tt_1" target="_blank">
                                        American Ultra
              <span>$5.500.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>7</i>
                                    <a href="http://www.imdb.com/title/tt4178092/?ref_=fn_al_tt_1" target="_blank">
                                        The Gift
              <span>$4.300.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>8</i>
                                    <a href="http://www.imdb.com/title/tt0478970/?ref_=fn_al_tt_1" target="_blank">
                                        Ant-Man
              <span>$4.088.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>9</i>
                                    <a href target="_blank" onclick="return false;">
                                        The Gift
              <span>$3.710.000</span>
                                    </a>
                                </li>
                                <li>
                                    <i>10</i>
                                    <a href target="_blank" onclick="return false;">
                                        Ant-Man
              <span>$3.650.000</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
